// import { createStore, applyMiddleware, compose } from "redux";
// import thunk from "redux-thunk";
// import combineReducer from "./combineReducers";

// const composeEnhancers =
//   typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
//     ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
//     : compose;

// const enhancer = composeEnhancers(applyMiddleware(thunk));

// const ConfigureStore = () => {
//   return createStore(combineReducer, enhancer);
// };

// export default ConfigureStore;


// import { createStore, applyMiddleware, compose } from "redux";
// import thunk from "redux-thunk";
// import { persistStore, persistReducer } from "redux-persist";
// import storage from "redux-persist/lib/storage"; // Defaults to localStorage for web

// import combineReducer from "./combineReducers";

// // Redux Persist configuration object
// const persistConfig = {
//   key: 'root', // The key for the persisted state in storage
//   storage, // The storage engine to use
//   // You can also add a whitelist or blacklist to control which parts of the state are persisted.
//   // whitelist: ['auth', 'userProfile'], // Example: only persist 'auth' and 'userProfile' states
// };

// // Create a persisted reducer by wrapping your root reducer
// const persistedReducer = persistReducer(persistConfig, combineReducer);

// const composeEnhancers =
//   typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
//     ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
//     : compose;

// const enhancer = composeEnhancers(applyMiddleware(thunk));

// const ConfigureStore = () => {
//   // Use the persisted reducer to create the store
//   const store = createStore(persistedReducer, enhancer);

//   // Create a persistor object
//   const persistor = persistStore(store);

//   // Return both the store and the persistor
//   return { store, persistor };
// };

// export default ConfigureStore;


import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // localStorage

import combineReducer from "./combineReducers";

// ✅ Only persist necessary slices
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["authReducer", "POSReducer"],
  version: 1, // increment this when store shape changes
  migrate: (state) => Promise.resolve(state), // safe migration, can reset if needed
};

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, combineReducer);

// Setup Redux DevTools
const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

const enhancer = composeEnhancers(applyMiddleware(thunk));

const ConfigureStore = () => {
  const store = createStore(persistedReducer, enhancer);
  const persistor = persistStore(store);

  return { store, persistor };
};

export default ConfigureStore;


